import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { isFieldEmpty } from "../../common/utils";
export var PASSWORD_VALIDATION_MESSAGE = "Password must be 8 chars long + 1 special character";
export var INITIAL_FIELD = {
  value: "",
  pristine: true
};
export var INITIAL_DROP_DOWN_FIELD = {
  label: "",
  value: "",
  pristine: true
};
export var INITIAL_BOOL_FIELD = {
  value: false,
  pristine: true
};
export var INITIAL_OBJECT_FIELD = {
  value: {},
  pristine: false
};
/**
 * Centralised Password validation
 *
 * @param {String} password
 */

export var isPasswordValid = function isPasswordValid(password) {
  var result = false;

  if (!password) {
    return result;
  }

  var checkSpecial = new RegExp("(?=.*[?|\\[\\]{}\"'()<>:;.,\\\\/\\!@#\\$%\\^&\\*_-])").test(password);
  var checkUpperLowerLength = new RegExp("(?=.*[a-zA-Z0-9])(?=.{8,})").test(password);
  var checkTilde = password.indexOf("~") === -1 ? false : true;

  if (checkUpperLowerLength && (checkSpecial || checkTilde)) {
    result = true;
  }

  return result;
};
export var areFieldsPristine = function areFieldsPristine(fields) {
  return Object.keys(fields).every(function (key) {
    var field = fields[key];
    return field && field.pristine;
  });
};
export var areFieldsTouched = function areFieldsTouched(fields) {
  return Object.keys(fields).some(function (key) {
    var field = fields[key];
    return field && !field.pristine;
  });
};
export var areAnyFieldsPristine = function areAnyFieldsPristine(fields) {
  return Object.keys(fields).some(function (key) {
    var field = fields[key];
    return field && field.pristine;
  });
};
export var getAllDirtyFields = function getAllDirtyFields(fields) {
  var data = {};
  Object.keys(fields).map(function (key) {
    var field = fields[key];

    if (!field.pristine) {
      data[key] = field.value;
    }
  });
  return data;
};
export var getAllFieldValues = function getAllFieldValues(fields) {
  var data = {};
  Object.keys(fields).map(function (key) {
    var field = fields[key];
    data[key] = field.value;
  });
  return data;
};
var REGEX_MAP = {
  specialChars: {
    pattern: "^[^`~!@#$%^&*()+={}\\[\\]|\\\\:;“<,>.?๐฿]*$",
    getError: function getError(label) {
      return "".concat(label, " doesn't support special characters");
    }
  },
  specialCharsNoNumbers: {
    pattern: "^[^\\d`~!@#$%^&*()+={}\\[\\]|\\\\:;“<,>.?๐฿]*$",
    getError: function getError(label) {
      return "".concat(label, " doesn't support special characters or numbers");
    }
  },
  cssCharsOnly: {
    pattern: "^[^`^{}<>]*",
    getError: function getError(label) {
      return "".concat(label, " doesn't support special characters or numbers");
    }
  }
};
export var validateLengthAndContent = function validateLengthAndContent(field, options) {
  var label = options.label,
      _options$regexType = options.regexType,
      regexType = _options$regexType === void 0 ? "cssCharsOnly" : _options$regexType,
      _options$maxLength = options.maxLength,
      maxLength = _options$maxLength === void 0 ? 128 : _options$maxLength,
      _options$minLength = options.minLength,
      minLength = _options$minLength === void 0 ? 1 : _options$minLength,
      _options$checkEmpty = options.checkEmpty,
      checkEmpty = _options$checkEmpty === void 0 ? true : _options$checkEmpty,
      dataKey = options.dataKey;
  var regexDetails = REGEX_MAP[regexType];
  var regex = RegExp(regexDetails.pattern, "g");
  var pristine = field.pristine,
      value = field.value;
  var error;

  if (!pristine) {
    if (isFieldEmpty(value) && checkEmpty) {
      error = "".concat(label, " is mandatory");
    } else if (!regex.test(value)) {
      error = regexDetails.getError(label);
    } else if (value.length > maxLength) {
      error = "".concat(label, " should be max ").concat(maxLength, " characters long");
    } else if (value.trim().length < minLength) {
      error = "".concat(label, " should be at least ").concat(minLength, " characters long");
    }
  }

  if (error) {
    return _defineProperty({}, dataKey, error);
  }

  return null;
};